import styled from 'styled-components';
import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';

const styles = `
  height: ${px2rem(35)};
  display: inline-block;
  overflow: visible;
  position: relative;
  text-align: right;
`;

export default buildStyledComponent(
  'SearchWrapper',
  styled.div,
  styles,
);



// WEBPACK FOOTER //
// ./components/Search/Wrapper.js